import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { Container } from "reactstrap";
import { scrollToTopSmooth } from "../../../util";
import { Button } from "reactstrap";
import { LineArrow } from "../../../components/SvgComponents";
import { useState, useEffect } from "react";

export default function AboutUs() {
   const history = useHistory();
   const [bgImage, setBgImage] = useState('');

   // Lazy load background image after component mounts
   useEffect(() => {
      // Delay loading this large image (2.7MB) until after critical content
      const timer = setTimeout(() => {
         import("../../../assets/images/backgrounds/about.png")
            .then(module => setBgImage(module.default))
            .catch(err => console.warn("Failed to load about image:", err));
      }, 1500); // Delay 1.5 seconds to prioritize other content
      
      return () => clearTimeout(timer);
   }, []);

   return (
      <section className="about-us-sec" style={{ backgroundImage: bgImage ? `url(${bgImage})` : 'none', backgroundColor: '#f5f5f5' }}>
         <Container>
            <h2 className="sec-title">About Discover Shurooq</h2>
            <p>Explore all of Shurooq’s destinations, services, and special offers from one stop.</p>
            {/* <Link to="/" onClick={scrollToTopSmooth} className="btn btn-primary">
          More
        </Link> */}

            <Button color="primary" style={{ width: 80 }} className="arrow" onClick={() => history.push(`/aboutus`)}>
               <span>
                  More
                  <LineArrow />
               </span>
            </Button>
         </Container>
      </section>
   );
}
